import { NgModule } from '@angular/core'

import { CmsComponentsBaseModule } from '../../cms-components-base.module'
import { ImageCarouselModalComponent } from './image-carousel-modal.component'
import { Image, TextInput } from '../../types'
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap'
import { MbI18nModule } from '../../../../translations/mb-i18n.module'
import { PictureModule } from '../picture/picture.module'
import { ModalImage } from '../image-modal/image-modal.module'
import { LinkModule } from '../link/link.module'

@NgModule({
  declarations: [
    ImageCarouselModalComponent,
  ],
  imports: [
    CmsComponentsBaseModule,
    NgbCarouselModule,
    MbI18nModule,
    PictureModule,
    LinkModule
  ],
  exports: [
    ImageCarouselModalComponent,
  ]
})
export class ImageCarouselModalModule {
}

export interface ImageCarouselData {
  viewportImages: ViewportImage[];
}

export interface ViewportImage {
  image: Image;
  caption: TextInput | undefined;
  description: TextInput | undefined;
  previewId?: string;
  mime?: string;
}

export interface MappedViewportImage {
  image: ModalImage;
  caption: TextInput | undefined;
  description: TextInput | undefined;
}
